<template>
  <div class="uikit_list">
    <uikit-list-item
      v-for="(item, i) in items"
      :icon="item.icon"
      :selected="item.selected"
      :light="light"
      :callback="item.callback"
      :name="item.name"
      :key="i"
    />
  </div>
</template>

<script>
import UikitListItem from "./component.uikit.list.item.vue";

export default {
  name: "uikitList",
  components: {
    UikitListItem,
  },
  props: {
    items: {
      type: Array,
      default: () => [],
    },
    light: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style scoped>
.uikit_list {
  display: flex;
  flex-direction: column;
}
</style>
